import { IconButton, Box } from "@mui/material";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useLang } from "../../context/LangContext";
import langIcon from "../../images/language.svg"; // Ensure this is a valid image import

const ChangeLang = () => {
  const { lang, changeLanguage } = useLang();
  const { t } = useTranslation();

  const toggleLang = () => {
    const newLang = lang === "en" ? "ar" : "en";
    changeLanguage(newLang);
    toast.success(t("langChanged"));
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconButton
        onClick={toggleLang}
        sx={{
          color: "white",
          backgroundColor: "transparent",
          borderRadius: "50%",
          padding: "8px",
          transition: "transform 0.2s ease, opacity 0.3s ease",
          "&:hover": {
            transform: "scale(1.1)",
            opacity: 0.8,
          },
          "&:focus": {
            outline: "2px solid white",
          },
        }}
      >
        <img
          src={langIcon}
          alt="Language Icon"
          style={{ width: 32, height: 32 }}
        />
      </IconButton>
    </Box>
  );
};

export default ChangeLang;
